module.exports = __webpack_public_path__ + "static/CSF0-11b9f4ad0af910b39917957af8294ee7.png";